import { DeliveryProvider } from '../../../../../services/exports/Constants';

export default {
  title: 'Tjek adressedækning',
  or: 'eller',
  form: {
    company: {
      label: 'Vælg restaurant',
    },
    address: {
      label: 'Indtast adressen',
    },
  },
  result: {
    positive: '{{address}} er berettiget til ekstern levering',
    negative: '{{address}} er ikke berettiget til ekstern levering',
  },
  providers: {
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
  buttons: {
    check: 'Tjek',
  },
  toasts: {
    error: 'Adressedækningen kunne ikke kontrolleres',
  },
};
